import {AUTHORITIES_ERROR,  GET_AUTHORITIES} from 'app/types'
import * as ActionTypes from 'app/types'

const initialState = {
    loading:true,
    data: JSON.parse(localStorage.getItem('authorities')),
    // data: {
    //     version: 0,
    //     isActivated: false,
    //     _id: "607a339cf531931043a3c163",
    //     email: "hm_mostefa1@esi.dz",
    //     authorities: [
    //         {
    //             has: {
    //                 read: true,
    //                 write: false
    //             },
    //             _id: "607a44a172a13913afa57d8b",
    //             entity: "points"
    //         },
    //         {
    //             has: {
    //                 read: false,
    //                 write: false
    //             },
    //             _id: "607a339cf531931043a3c165",
    //             entity: "payments"
    //         },
    //         {
    //             has: {
    //                 read: true,
    //                 write: false
    //             },
    //             _id: "607a339cf531931043a3c166",
    //             entity: "timeslots"
    //         },
    //         {
    //             has: {
    //                 read: true,
    //                 write: false
    //             },
    //             _id: "607a339cf531931043a3c167",
    //             entity: "lines"
    //         },
    //         {
    //             has: {
    //                 read: false,
    //                 write: false
    //             },
    //             _id: "607a339cf531931043a3c168",
    //             entity: "bookings"
    //         },
    //         {
    //             has: {
    //                 read: false,
    //                 write: false
    //             },
    //             _id: "607a339cf531931043a3c169",
    //             entity: "trips"
    //         },
    //         {
    //             has: {
    //                 read: false,
    //                 write: false
    //             },
    //             _id: "607a339cf531931043a3c16a",
    //             entity: "drivers"
    //         },
    //         {
    //             has: {
    //                 read: false,
    //                 write: false
    //             },
    //             _id: "607a339cf531931043a3c16b",
    //             entity: "riders"
    //         },
    //         {
    //             has: {
    //                 read: false,
    //                 write: false
    //             },
    //             _id: "607a339cf531931043a3c16c",
    //             entity: "notifications"
    //         },
    //         {
    //             has: {
    //                 read: false,
    //                 write: false
    //             },
    //             _id: "607a339cf531931043a3c16d",
    //             entity: "code promo"
    //         },
    //         {
    //             has: {
    //                 read: false,
    //                 write: false
    //             },
    //             _id: "607a339cf531931043a3c16e",
    //             entity: "contactus"
    //         },
    //         {
    //             has: {
    //                 read: true,
    //                 write: false
    //             },
    //             _id: "607a339cf531931043a3c16f",
    //             entity: "users"
    //         }
    //     ],
    //     createdAt: "2021-04-17T01:02:20.728Z",
    //     updatedAt: "2021-04-17T02:14:57.906Z",
    //     __v: 1,
    //     role: "super_admin",
    //
    // }
}

export default function authReducer (state = initialState, action) {

    switch(action.type){
        case GET_AUTHORITIES:
            return {
                ...state,
                data : action.payload ,
                loading : false
            }
        case AUTHORITIES_ERROR :
            return {
                loading: false ,
                error : action.payload
            }
        case ActionTypes.LOGIN_DASHBOARD_USER :
            return {
                ...state ,
                loading: false,
                data : action.payload
            }
        default: return state
    }

}

